"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChromiumBased = isChromiumBased;
exports.isMobileDevice = isMobileDevice;
function isChromiumBased() {
  var userAgent = navigator.userAgent;
  var isChromium = userAgent.includes('Chrome') || userAgent.includes('Chromium') || userAgent.includes('Edg');
  return isChromium;
}
function isMobileDevice() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // List mobile user agents
  var mobileDevices = [/android/i, /webos/i, /iphone/i, /ipad/i, /ipod/i, /blackberry/i, /windows phone/i];
  for (var _i = 0, _mobileDevices = mobileDevices; _i < _mobileDevices.length; _i++) {
    var device = _mobileDevices[_i];
    if (userAgent.match(device)) {
      return true;
    }
  }
  return false;
}